module.exports = __webpack_public_path__ + "img/SS10.13bd56e4.jpg";